jQuery(($) => {

    if ($('.m-testimonial-cards--is-slider')[0]) {
        $('.m-testimonial-cards--is-slider .m-testimonial-cards__list').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            appendArrows: '.m-testimonial-cards--is-slider .js-arrow-navigation',
            appendDots: '.m-testimonial-cards--is-slider .js-dot-navigation',
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }]
        });
    } 
});